export default __webpack_public_path__ + "static/media/modal_pen_icon.95d9ff67.svg";